import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import Loader from "../common/loader";
import { BaseUrl } from "../common/config";
import Sidebar from "../common/sidebar";
import CommonAlert from "../common/Commonalert";
import { http } from "../helper";
import { canAction } from "../common/permissionhelper";
import { useTranslation } from "react-i18next";
const MODULE = "manage_freeproducts";

const Editfreeproducts = () => {
  const { t } = useTranslation();
  const canEdit = canAction(MODULE, "edit");
  const isReadOnly = !canEdit; // if true, disable inputs and hide submit
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [freeproducts, setfreeProducts] = useState([]);
  const [categoryVal, setCategoryVal] = useState([]);
  const [freecategoryVal, setfreeCategoryVal] = useState([]);
  const [checkedval, setCheckedval] = useState([]);
  const [checkedfreeval, setCheckedfreeval] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [offerexpanded, setOfferExpanded] = useState(false);
  const [checkedState, setCheckedState] = useState([]);
  const [checkedfreeState, setCheckedfreeState] = useState([]);
  const [inputlimitField, setInputlimitField] = useState([]);
  const [inputfreelimitField, setInputfreelimitField] = useState([]);
  const [inputFieldtitle, setInputFieldtitle] = useState([]);
  const [errmessage, setErrMessage] = useState({});
  const [selectedCategories, setSelectedCategories] = useState([
    "pizza",
    "pasta",
    "desserts"
  ]);
  const [selectedFreeCategories, setSelectedFreeCategories] = useState([
    "pizza",
    "pasta",
    "desserts"
  ]);
  const [filteredProduct, setFilteredProduct] = useState([]);
  const [filteredFreeProduct, setFilteredFreeProduct] = useState([]);
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState([]);
  const params = useParams();

  if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_freeproducts")
  ) {
    window.location.href = "/unauthorized";
  }

  function routeChange(e) {
    e.preventDefault();
    window.location.href = "/freeproducts";
    return false;
  }
  // Map of category names to category IDs
  const categoryMap = {
    pizza: ["1"],
    pasta: ["10", "13", "11", "12"],
    desserts: ["14"]
  };

  let categoryid = {};
  useEffect(() => {
    const filteredProducts = getFilteredProducts();
    const arry = filteredProducts.map((prd) => {
      // Check if the productNumber is included in the checkedval array
      if (prd.PDP_Status === "deactivate") {
        return false;
      }
      return checkedval.includes(prd.productNumber);
    });
    setCheckedState(arry);
    setFilteredProduct(filteredProducts);
  }, [products, checkedval, selectedCategories]);

  useEffect(() => {
    const filteredFreeProducts = getFilteredFreeProducts();
    const arry = filteredFreeProducts.map((prd) => {
      // Check if the productNumber is included in the checkedval array
      if (prd.PDP_Status === "deactivate") {
        return false;
      }
      return checkedfreeval.includes(prd.productNumber);
    });
    setCheckedfreeState(arry);
    setFilteredFreeProduct(filteredFreeProducts);
  }, [freeproducts, checkedfreeval, selectedFreeCategories]);

  useEffect(() => {
    setCheckedState(new Array(products.length).fill(false));
    setCheckedval([]);
  }, [inputlimitField]);

  useEffect(() => {
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    let URL1 = BaseUrl + `admin/offer/${params.id}`;
    http
      .get(URL1)
      .then((response) => {
        let responseData = response.data.data;
        setLoading(false);
        setInputFieldtitle(responseData.offerTitle);
        setInputlimitField(responseData.productQtyToBeAdded);
        setCategoryVal(responseData.categoryId);
        setCheckedval(responseData.productToBeAdded.split(","));
        setInputfreelimitField(responseData.freeProductQtyToAdd);
        setfreeCategoryVal(responseData.freeCategoryId);
        setCheckedfreeval(responseData.freeProductToAdd.split(","));
      })
      .catch((err) => {
        console.log(err);
      });
    var priceCode = "PL1";
    let URL = `${BaseUrl}admin/productprice/${priceCode}`;
    http
      .get(URL)
      .then((response) => {
        let responseData = response.data.data;
        setProducts(responseData);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    var priceCode = "PL1";
    let URL = `${BaseUrl}admin/productprice/${priceCode}`;
    http
      .get(URL)
      .then((response) => {
        let responseData = response.data.data;
        setProducts(responseData);
        setfreeProducts(responseData);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  const handleOnChange = (position, e) => {
    const updatedCheckedState = checkedState.map((item, index) => {
      return index === position ? !item : item;
    });
    var updatedList = [...checkedval];
    if (e.target.checked) {
      updatedList = [...checkedval, e.target.value];
    } else {
      updatedList.splice(checkedval.indexOf(e.target.value), 1);
    }
    setCheckedval(updatedList);
    setCheckedState(updatedCheckedState);
  };
  //Free Product checkstate
  const handleOnChange1 = (position, e) => {
    const updatedfreeCheckedState = checkedfreeState.map((item, index) => {
      return index === position ? !item : item;
    });
    var updatedList = [...checkedfreeval];
    if (e.target.checked) {
      updatedList = [...checkedfreeval, e.target.value];
    } else {
      updatedList.splice(checkedfreeval.indexOf(e.target.value), 1);
    }
    setCheckedfreeval(updatedList);
    setCheckedfreeState(updatedfreeCheckedState);
  };

  const submitButton = (e) => {
    e.preventDefault();
    const isValid = formvalidation();
    if (isValid) {
      var loginDetails = {};
      if (sessionStorage.getItem("authData")) {
        loginDetails = JSON.parse(sessionStorage.getItem("authData"));
      }
      const activeSelectedProducts = checkedval.filter((productNumber) => {
        const product = products.find((p) => p.productNumber === productNumber);
        return product && product.PDP_Status !== "deactivate";
      });
      let payload = {
        offerid: params.id,
        offerTitle: inputFieldtitle.trim(),
        categoryId: categoryVal,
        productToBeAdded: activeSelectedProducts.toString(),
        productQtyToBeAdded: parseInt(inputlimitField),
        freeProductToAdd: checkedfreeval.toString(),
        freeProductQtyToAdd: parseInt(inputlimitField),
        freeCategoryId: freecategoryVal,
        productExtToBeAdded: checkedfreeval.toString(),
        status: "A",
      };
      let URL = BaseUrl + "admin/offer/";
      http
        .put(URL, payload)
        .then((response) => {
          let responseData = response.data.data;
          if (response.data.success === true) {
            setAlertPopup(true);
            setAlertMessage(t("free_products_updated_successfully_txt"));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleclick = () => {
    setExpanded(!expanded);
  };

  const handleOfferclick = () => {
    setOfferExpanded(!offerexpanded);
  };

  const formvalidation = () => {
    const errmessage = {};
    let isValid = true;
    if (inputFieldtitle == "") {
      errmessage.inputfieldtitleerr = t("title_required_txt");
      isValid = false;
    }
    if (inputlimitField == "") {
      errmessage.inputlimitfielderr = t("product_limit_required_txt");
      isValid = false;
    }
    if (checkedval == "") {
      errmessage.checkedValerr = t(
        "products_should_be_selected_based_on_limit_txt",
      );
      isValid = false;
    }
    if (checkedfreeval == "") {
      errmessage.checkedfreeValerr = t(
        "products_should_be_selected_based_on_limit_txt",
      );
      isValid = false;
    }
    setErrMessage(errmessage);
    return isValid;
  };

  const eventhandlechange = (e) => {
    const re = /^[0-9\b]+$/;
    if (e.target.name == "inputFieldtitle") {
      setInputFieldtitle(e.target.value);
      setLoading(false);
    }
    if (e.target.name == "inputlimitField") {
      if (e.target.value === "" || re.test(e.target.value)) {
        setInputlimitField(e.target.value);
        setLoading(false);
      }
    }
    if (e.target.name === "inputfreelimitField") {
      setInputfreelimitField(e.target.value);
    }
  };
  // Handle category checkbox change
  const handleCategoryChange = (e) => {
    const { name, checked } = e.target;
    setSelectedCategories((prevSelectedCategories) => {
      if (checked) {
        // Add the category if it's checked
        return [...prevSelectedCategories, name];
      } else {
        // Remove the category if it's unchecked
        return prevSelectedCategories.filter((cat) => cat !== name);
      }
    });
  };

  const handleFreeCategoryChange = (e) => {
    const { name, checked } = e.target;
    setSelectedFreeCategories((prevSelectedFreeCategories) => {
      if (checked) {
        // Add the category if it's checked
        return [...prevSelectedFreeCategories, name];
      } else {
        // Remove the category if it's unchecked
        return prevSelectedFreeCategories.filter((cat) => cat !== name);
      }
    });
  };

  const getFilteredProducts = () => {
    // If no category is selected, show all products
    const selectedCategoryIds = selectedCategories
      .map((category) => categoryMap[category])
      .flat(); // Flatten the array to merge all IDs into one array
    // Filter products based on the selected category IDs
    return products.filter((prd) =>
      selectedCategoryIds.includes(prd.categoryId),
    );
  };

  const getFilteredFreeProducts = () => {
    const selectedFreeCategoryIds = selectedFreeCategories
      .map((category) => categoryMap[category])
      .flat(); // Flatten the array to merge all IDs into one array
    // Filter products based on the selected category IDs
    return freeproducts.filter((prd) =>
      selectedFreeCategoryIds.includes(prd.categoryId),
    );
  };

  return (
    <section className="dashboard-block">
      {alertPopup && (
        <CommonAlert title={t("alert_txt")} message={alertMessage} />
      )}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container">
            <div className="flex-title">
              <h1 className="checkout-title">
                {canEdit
                  ? t("edit_free_products_setup_txt")
                  : t("view_free_products_setup_txt")}
              </h1>
              <div className="back-btn">
                <button title={t("back_txt")} onClick={(e) => routeChange(e)}>
                  {t("back_txt")}
                </button>
              </div>
            </div>
            <div className="right-table-outer-wrap">
              {loading ? (
                <div className="loading-buffer"></div>
              ) : (
                <form
                  method="post"
                  className="editform freeprod-forms"
                  onSubmit={submitButton}
                >
                  <div className="freeproduct-fieldset">
                    <div className="input-field">
                      <label>{t("title_txt")}</label>
                      <input
                        type="text"
                        value={inputFieldtitle}
                        name="inputFieldtitle"
                        onChange={eventhandlechange}
                        className="form-control"
                        placeholder={t("title_txt")}
                        readOnly={isReadOnly}
                      />
                      {errmessage.inputfieldtitleerr && (
                        <div className="error-msg">
                          {errmessage.inputfieldtitleerr}
                        </div>
                      )}
                    </div>
                    <div className="input-field ">
                      <label>{t("offer_products_to_be_added_txt")}</label>
                      <input
                        type="text"
                        value={inputlimitField}
                        name="inputlimitField"
                        onChange={eventhandlechange}
                        className="form-control"
                        placeholder={t("products_limit_txt")}
                        readOnly={isReadOnly}
                      />
                      {errmessage.inputlimitfielderr && (
                        <div className="error-msg">
                          {errmessage.inputlimitfielderr}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="accordion-box">
                    <div
                      onClick={handleOfferclick}
                      className={
                        offerexpanded === true
                          ? "accordion-header show"
                          : "accordion-header"
                      }
                    >
                      <h2>{t("offer_products_txt")}</h2>
                      <span className="show-accordion"></span>
                    </div>
                    <div
                      className="accordion-body"
                      style={{
                        display: offerexpanded === true ? "block" : "none",
                      }}
                    >
                      <div className="custom_check-box">
                        <div className="edit-free-cat-disp">
                          <h4>{t("category_txt")}</h4>
                          <div className="edit-free-cat-chks">
                            <div className="check-box">
                              <input
                                type="checkbox"
                                id="cat01"
                                name="pizza"
                                onChange={(e) => {
                                  if (isReadOnly) return;
                                  handleCategoryChange(e);
                                }}
                                checked={selectedCategories.includes("pizza")}
                              />
                              <label htmlFor="cat01">{t("pizza_txt")}</label>
                            </div>
                            <div className="check-box">
                              <input
                                type="checkbox"
                                id="cat02"
                                name="pasta"
                                onChange={(e) => {
                                  if (isReadOnly) return;
                                  handleCategoryChange(e);
                                }}
                                checked={selectedCategories.includes("pasta")}
                              />
                              <label htmlFor="cat02">{t("pasta_txt")}</label>
                            </div>
                            <div className="check-box">
                              <input
                                type="checkbox"
                                id="cat04"
                                name="desserts"
                                onChange={(e) => {
                                  if (isReadOnly) return;
                                  handleCategoryChange(e);
                                }}
                                checked={selectedCategories.includes(
                                  "desserts",
                                )}
                              />
                              <label htmlFor="cat04">{t("desserts_txt")}</label>
                            </div>
                          </div>
                          {filteredProduct.length === 0 && (
                            <p className="color-red">
                              {t("please_select_category_to_view_products_txt")}
                            </p>
                          )}
                          {filteredProduct.length > 0 && (
                            <h4>{t("offer_products_to_be_added_txt")}</h4>
                          )}
                          {filteredProduct
                            .filter((prd) => {
                              if (isReadOnly) {
                                // Only show checked and active products when read-only
                                return (
                                  checkedval.includes(prd.productNumber) &&
                                  prd.PDP_Status !== "deactivate"
                                );
                              }
                              // Edit show all
                              return true;
                            })
                            .map((prd, index) => {
                              const isreadOnlyOrDeactivated =
                                prd.PDP_Status === "deactivate" || isReadOnly;
                              return (
                                <div
                                  className="check-box"
                                  key={prd.productNumber}
                                >
                                  <input
                                    type="checkbox"
                                    id={`chkbox${index}`}
                                    name="prd_chkbox"
                                    value={prd.productNumber}
                                    checked={
                                      prd.PDP_Status === "deactivate"
                                        ? false
                                        : checkedval.includes(prd.productNumber)
                                    }
                                    onChange={(e) => {
                                      if (isreadOnlyOrDeactivated) return;
                                      handleOnChange(index, e);
                                    }}
                                    readOnly={isReadOnly}
                                    disabled={prd.PDP_Status === "deactivate"}
                                  />
                                  <label htmlFor={`chkbox${index}`}>
                                    {prd.productDescription} (
                                    {prd.productNumber})
                                  </label>
                                </div>
                              );
                            })}
                          {errmessage.checkedValerr && (
                            <div className="error-msg">
                              {errmessage.checkedValerr}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-box">
                    <div
                      onClick={handleclick}
                      className={
                        expanded === true
                          ? "accordion-header show"
                          : "accordion-header"
                      }
                    >
                      <h2>{t("free_products")}</h2>
                      <span className="show-accordion"></span>
                    </div>
                    <div
                      className="accordion-body"
                      style={{ display: expanded === true ? "block" : "none" }}
                    >
                      <div className="custom_check-box">
                        <div className="edit-free-cat-disp">
                          <h4>{t("category_txt")}</h4>
                          <div className="edit-free-cat-chks">
                            <div className="check-box">
                              <input
                                type="checkbox"
                                id="fcat01"
                                name="pizza"
                                onChange={(e) => {
                                  if (isReadOnly) return;
                                  handleFreeCategoryChange(e);
                                }}
                                checked={selectedFreeCategories.includes(
                                  "pizza",
                                )}
                              />
                              <label htmlFor="fcat01">{t("pizza_txt")}</label>
                            </div>
                            <div className="check-box">
                              <input
                                type="checkbox"
                                id="fcat02"
                                name="pasta"
                                onChange={(e) => {
                                  if (isReadOnly) return;
                                  handleFreeCategoryChange(e);
                                }}
                                checked={selectedFreeCategories.includes(
                                  "pasta",
                                )}
                              />
                              <label htmlFor="fcat02">{t("pasta_txt")}</label>
                            </div>
                            <div className="check-box">
                              <input
                                type="checkbox"
                                id="fcat04"
                                name="desserts"
                                onChange={(e) => {
                                  if (isReadOnly) return;
                                  handleFreeCategoryChange(e);
                                }}
                                checked={selectedFreeCategories.includes(
                                  "desserts",
                                )}
                              />
                              <label htmlFor="fcat04">
                                {t("desserts_txt")}
                              </label>
                            </div>
                          </div>
                          {filteredFreeProduct.length === 0 && (
                            <p className="color-red">
                              {t("please_select_category_to_view_products_txt")}
                            </p>
                          )}
                          {filteredFreeProduct.length > 0 && (
                            <h4>{t("free_products")}</h4>
                          )}
                          {filteredFreeProduct
                            .filter((prd) => {
                              if (isReadOnly) {
                                // Only show checked & active free products when read-only
                                return (
                                  checkedfreeval.includes(prd.productNumber) &&
                                  prd.PDP_Status !== "deactivate"
                                );
                              }
                              // Edit  show all
                              return !checkedval.includes(prd.productNumber);
                            })
                            .map((prd, index) => {
                              const isreadOnlyOrDeactivated =
                                prd.PDP_Status === "deactivate" || isReadOnly;
                              return (
                                <div
                                  className="check-box"
                                  key={prd.productNumber}
                                >
                                  <input
                                    type="checkbox"
                                    id={`freechkbox${index}`}
                                    name="freeprd_chkbox"
                                    value={prd.productNumber}
                                    checked={
                                      prd.PDP_Status === "deactivate"
                                        ? false
                                        : checkedfreeval.includes(
                                            prd.productNumber,
                                          )
                                    }
                                    onChange={(e) => {
                                      if (isreadOnlyOrDeactivated) return;
                                      handleOnChange1(index, e);
                                    }}
                                    readOnly={isReadOnly}
                                    disabled={prd.PDP_Status === "deactivate"}
                                  />
                                  <label htmlFor={`freechkbox${index}`}>
                                    {prd.productDescription} (
                                    {prd.productNumber})
                                  </label>
                                </div>
                              );
                            })}
                          {errmessage.checkedfreeValerr && (
                            <div className="error-msg">
                              {errmessage.checkedfreeValerr}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {!isReadOnly && (
                    <button title={t("update_txt")} type="submit">
                      {t("update_txt")}
                    </button>
                  )}
                  &nbsp;&nbsp;{" "}
                  <button
                    title={t("cancel_txt")}
                    onClick={(e) => routeChange(e)}
                  >
                    {t("cancel_txt")}
                  </button>
                </form>
              )}
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </section>
  );
};
export default Editfreeproducts;
